import React, { forwardRef } from "react";
import { IoMdClose } from "react-icons/io";

import { Filter, FilterContainer, FilterContent, FilterHeader } from "./styles";

const Filters = (
  { children, className, handleAllFilters, filterType, isScreenLock },
  ref
) => {
  return (
    <>
      <Filter
        className={className}
        viewAllFilters={className === "show" ? true : false}
        onClick={() => {
          if (!isScreenLock) {
            handleAllFilters();
          }
        }}
      />
      <FilterContainer viewAllFilters={className === "show" ? true : false}>
        <FilterHeader>
          <span>Filtrar {filterType} por</span>
          <button
            onClick={() => {
              if (!isScreenLock) {
                handleAllFilters();
              }
            }}
          >
            <IoMdClose size={25} />
          </button>
        </FilterHeader>
        <FilterContent ref={ref}>{children}</FilterContent>
      </FilterContainer>
    </>
  );
};

export default forwardRef(Filters);
